interface Brand {
  name: string;
  logo: string;
}

const brands: Brand[] = [
  {
    name: "Noa Wellness",
    logo: "/noa.png",
  },
  {
    name: "The Wellness Project",
    logo: "/wellness_project.png",
  },
  {
    name: "15 Buttons",
    logo: "/15buttons.png",
  },
  {
    name: "House of Alkka",
    logo: "/House of Alkka.png",
  },
  {
    name: "NJS",
    logo: "/NJS.png",
  },
  {
    name: "SuperBolter",
    logo: "/SuperBolter.png",
  },
];

export default function BrandsCarousel() {
  // Duplicate brands for seamless infinite scroll
  const duplicatedBrands = [...brands, ...brands];

  return (
    <section className="py-16 bg-base-100 overflow-hidden">
      <div className="max-w-5xl mx-auto px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-wider opacity-60 mb-2">
            Trusted by leading brands
          </p>
          <h2 className="text-2xl lg:text-3xl font-bold">
            Brands that trust Gamgee
          </h2>
        </div>
      </div>

      {/* Infinite Scrolling Carousel */}
      <div className="relative">
        {/* Gradient masks for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-base-100 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-base-100 to-transparent z-10 pointer-events-none" />

        {/* Scrolling track */}
        <div className="flex animate-scroll">
          {duplicatedBrands.map((brand, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-8 lg:mx-12"
            >
              <div className="h-20 lg:h-24 flex items-center justify-center opacity-70">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="h-full w-auto object-contain max-w-[160px] lg:max-w-[200px]"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </section>
  );
}
